import "./index.scss";

export const OrderInfo = ({
  payment,
  bill_address,
  number: orderId,
  date_formatted
}) => {
  const { first_name, last_name, street, city, state, zip } = bill_address;
  const { cc_type, last_digits, year, month } = payment;

  const formatted_address = `${street.join(" ")}, ${city} ${state} ${zip}`;

  return (
    <div className="order-info">
      <h2>Your Order #{orderId}</h2>
      <p>
        <strong>Order Number:</strong> {orderId}
      </p>
      <p>
        <strong>Order Date:</strong> {date_formatted}
      </p>
      <p>
        <strong>Billed To:</strong> {first_name} {last_name},{" "}
        {formatted_address}
      </p>
      <p>
        <span>
          <strong>Payment Method:</strong>
          <span className={`card-type ${cc_type}`} />
          <strong>{cc_type}</strong> ending in <strong>{last_digits}</strong>{" "}
          expires {month}/{year}
        </span>
      </p>
    </div>
  );
};
